// Výpis Slovníku pojmů (nativní doplněk, body.type-glossary) — karty s obrázkem a písmenkový filtr.
// Doplněk pole pro obrázek nemá: obrázek je první obrázek v obsahu pojmu a výpis si ho z detailu
// načte sám (max. N souběžných požadavků, výsledek v sessionStorage). Texty: shopDataLayer.glossaryListing.

const glossaryImageStoragePrefix = "myglossary-image:";
const glossaryImageMemory = {};
const glossaryImagePending = {};
const glossaryImageQueue = [];
let glossaryImageRunning = 0;

function getGlossaryListingSettings() {
    return window.shopDataLayer && window.shopDataLayer.glossaryListing ? window.shopDataLayer.glossaryListing : null;
}

function readGlossaryImageCache(path) {
    if (glossaryImageMemory[path]) {
        return glossaryImageMemory[path];
    }

    try {
        const stored = window.sessionStorage.getItem(glossaryImageStoragePrefix + path);
        return stored ? JSON.parse(stored) : null;
    } catch (e) {
        return null;
    }
}

function writeGlossaryImageCache(path, image) {
    glossaryImageMemory[path] = image;

    try {
        window.sessionStorage.setItem(glossaryImageStoragePrefix + path, JSON.stringify(image));
    } catch (e) {
        // Plné nebo zakázané úložiště — zůstane jen paměť stránky
    }
}

// Absolutní adresa obrázku vůči stránce pojmu
function resolveGlossaryImageUrl(src, path) {
    const link = document.createElement("a");
    link.href = path;
    return new URL(src, link.href).href;
}

// První obrázek obsahu pojmu — přednostně .myglossary-image, nikdy obrázky produktových karet
function findGlossaryImage(doc, path) {
    const $detail = $(doc).find(".glossaryDetail");
    let $img = $detail.find(".myglossary-image img").first();

    if (!$img.length) {
        $img = $detail.find("img").filter(function () {
            return !$(this).closest(".dmproducts, .products, .product, .products-block, .myarticle-products, .myarticle-term, .myarticle-author").length;
        }).first();
    }

    const src = $img.attr("data-src") || $img.attr("src") || "";

    if (!src || src.indexOf("data:") === 0) {
        return { src: "" };
    }

    return {
        src: resolveGlossaryImageUrl(src, path),
        alt: $img.attr("alt") || "",
    };
}

function runGlossaryImageQueue() {
    const settings = getGlossaryListingSettings();

    while (glossaryImageRunning < settings.maxRequests && glossaryImageQueue.length) {
        const task = glossaryImageQueue.shift();

        glossaryImageRunning++;

        $.ajax({
            url: task.path,
            dataType: "html",
            timeout: settings.timeout,
        }).done(function (data) {
            const image = findGlossaryImage(new DOMParser().parseFromString(data, "text/html"), task.path);
            writeGlossaryImageCache(task.path, image);
            task.deferred.resolve(image);
        }).fail(function () {
            // Chyba se neukládá — při dalším zobrazení výpisu se zkusí znovu
            task.deferred.resolve(null);
        }).always(function () {
            glossaryImageRunning--;
            runGlossaryImageQueue();
        });
    }
}

// Jeden požadavek na URL, i když je pojem ve výpisu vícekrát
function loadGlossaryImage(path) {
    if (!glossaryImagePending[path]) {
        const deferred = $.Deferred();

        glossaryImagePending[path] = deferred.promise();
        glossaryImageQueue.push({ path: path, deferred: deferred });
        deferred.always(function () {
            delete glossaryImagePending[path];
        });
        runGlossaryImageQueue();
    }

    return glossaryImagePending[path];
}

function getGlossaryLocalPath(url) {
    const link = document.createElement("a");
    link.href = url;

    if (link.hostname.replace(/^www\./, "") !== window.location.hostname.replace(/^www\./, "")) {
        return null;
    }

    return link.pathname;
}

function renderGlossaryImage($item, image) {
    const $holder = $item.children(".myglossary-item-image");

    if (!image || !image.src) {
        $holder.remove();
        $item.addClass("myglossary-item--no-image").removeClass("is-loading");
        return;
    }

    const $img = $("<img loading='lazy'>")
        .attr("alt", image.alt || $.trim($item.find("h2").first().text()))
        .on("load error", function (e) {
            $item.removeClass("is-loading");

            if (e.type === "error") {
                $holder.remove();
                $item.addClass("myglossary-item--no-image");
            } else {
                $holder.addClass("is-loaded");
            }
        })
        .attr("src", image.src);

    $holder.append($img);
}

function initGlossaryItems($listing) {
    $listing.children("h2").each(function () {
        const $title = $(this);
        const $link = $title.find("a").first();
        const path = $link.length ? getGlossaryLocalPath($link.attr("href")) : null;
        const $item = $("<div class='myglossary-item'></div>").insertBefore($title);

        $item.append($title);

        if ($title.next().is("p")) {
            $item.append($title.next().addClass("myglossary-item-text"));
        }

        if (!path) {
            $item.addClass("myglossary-item--no-image");
            return;
        }

        $("<a class='myglossary-item-image' tabindex='-1' aria-hidden='true'></a>")
            .attr("href", $link.attr("href"))
            .prependTo($item);

        const cached = readGlossaryImageCache(path);

        if (cached) {
            renderGlossaryImage($item, cached);
            return;
        }

        $item.addClass("is-loading");

        loadGlossaryImage(path).then(function (image) {
            renderGlossaryImage($item, image);
        });
    });
}

// Písmena vykresluje doplněk jako odstavec za h1: odkazy ?letter=X, vybrané písmeno jako <strong>
function initGlossaryLetters(settings) {
    const $letters = $(".type-glossary .content-inner > p").filter(function () {
        const $paragraph = $(this);

        return $paragraph.next("#glossaryListHeading").length > 0 || $paragraph.find("a[href*='letter=']").length > 0;
    }).first().not(".myglossary-letters");

    if (!$letters.length) {
        return;
    }

    const activeLetter = new URLSearchParams(window.location.search).get("letter");

    $letters.addClass("myglossary-letters");

    $letters.children("a").each(function () {
        const isActive = !!activeLetter && new URLSearchParams(this.search).get("letter") === activeLetter;

        $(this)
            .addClass("myglossary-letter")
            .toggleClass("is-active", isActive)
            .attr("aria-current", isActive ? "true" : null);
    });

    $letters.children("strong").addClass("myglossary-letter is-active").attr("aria-current", "true");

    if (settings.allLettersText) {
        $("<a class='myglossary-letter'></a>")
            .attr("href", window.location.pathname)
            .text(settings.allLettersText)
            .toggleClass("is-active", !activeLetter)
            .attr("aria-current", !activeLetter ? "true" : null)
            .prependTo($letters);
    }
}

function initGlossaryListing() {
    const settings = getGlossaryListingSettings();
    const $listing = $(".type-glossary #glossary-listing").not("[data-myglossary-done]");

    if (!settings || !settings.enabled || !$listing.length) {
        return;
    }

    // Styly výpisu platí jen s těmito třídami — s enabled: false zůstane nativní vzhled
    $listing.attr("data-myglossary-done", "1").addClass("myglossary-list");
    $(".type-glossary .listingControls").addClass("myglossary-controls");

    initGlossaryLetters(settings);
    initGlossaryItems($listing);
}

$(document).ready(function () {
    initGlossaryListing();
});

document.addEventListener("ShoptetDOMContentLoaded", function () {
    initGlossaryListing();
});
